import React, { useCallback, useEffect } from "react";

import { useAPI } from "kw/api/useAPI";
import { useLocation } from "@reach/router";
import { parse } from "query-string";
import { Placeholder } from "kanopi-components/Placeholder";
import { fromLocalStorage } from "kanopi-components/utils/browser";

export function SsoAuthenticatorLogin() {
  const { mutation } = useAPI();

  const location = useLocation();
  const searchParams = parse(location.search);
  const type = searchParams?.type
    ? searchParams?.type
    : fromLocalStorage("authenticator_type", "");

  const initSsoLogin = useCallback(() => {
    mutation(
      {
        ssoAuthenticate: [
          {
            authenticatorType: type,
          },
          {
            url: true,
          },
        ],
      },
      async (response) => {
        if (response?.ssoAuthenticate?.url) {
          window.location.href = response?.ssoAuthenticate?.url;
        }
      }
    );
  }, [type]);

  useEffect(() => {
    initSsoLogin();
  }, [type]);
  return <Placeholder loading={true} />;
}
